export default __webpack_public_path__ + "static/media/actividadesempleados_old.71e488d9.png";